import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Spacer,
  Button,
  useBreakpointValue,
} from "@chakra-ui/react";

import { useState } from "react";
import { useNavigate } from "react-router-dom";

const NavCard = ({ text, backText, url, mT }) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const navigate = useNavigate();

  const cardFontSize = useBreakpointValue({ base: "30px", md: "40px" });
  const cardHeight = useBreakpointValue({ base: "220px", md: "280px" });
  const cardWidth = useBreakpointValue({ base: "150px", md: "185px" });

  const handleCardFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const handleClick = (e) => {
    e.stopPropagation();
    navigate(`/${url}`);
  };

  return (
    <div
      className={`flippable-card ${isFlipped ? "flipped" : ""}`}
      onClick={handleCardFlip}
      style={{ marginTop: mT, height: cardHeight, width: cardWidth }}
    >
      <div className="front">
        {" "}
        <Card
          h={cardHeight}
          w={cardWidth}
          fontSize={cardFontSize}
          borderRadius="10px"
          border="2px solid white"
          bg="primarytxt.600"
          _hover={{ bg: "headline.400" }}
          color="white"
        >
          {" "}
          <CardHeader
            fontFamily="Shantell Sans"
            fontSize={{ base: "20px", md: "30px" }}
          >
            LS
          </CardHeader>
          <Spacer />
          <CardBody alignSelf="center">{text}</CardBody>
          <Spacer />
          <CardFooter
            alignSelf="end"
            fontFamily="Shantell Sans"
            fontSize={{ base: "20px", md: "30px" }}
            style={{ transform: "rotate(180deg)" }}
          >
            LS
          </CardFooter>
        </Card>
      </div>
      <div className="back">
        {" "}
        <Card
          h={cardHeight}
          w={cardWidth}
          fontSize={{ base: "15px", md: "18px" }}
          borderRadius="10px"
          border="2px solid black"
        >
          {" "}
          <CardBody alignSelf="center">{backText}</CardBody>
          <Spacer />
          <Button
            onClick={handleClick}
            height={{ base: "40px", md: "80px" }}
            fontSize={{ base: "18px", md: "20px" }}
            color="primarytxt.700"
            bg="headline.200"
            _hover={{ bg: "headline.400" }}
          >
            {text}
          </Button>
        </Card>
      </div>
    </div>
  );
};
export default NavCard;
